module.exports = __webpack_public_path__ + "static/img/soc1.6283bf28.jpg";